var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListView',{attrs:{"title":"LoginAccounts","search":_vm.search,"data":_vm.data,"page":_vm.page},on:{"reload":_vm.reload,"create":_vm.actionCreate,"update:search":function($event){_vm.search=$event},"update:page":function($event){_vm.page=$event}},scopedSlots:_vm._u([{key:"card",fn:function(ref){
var cardContent = ref.cardContent;
return [_c('Card',{attrs:{"content":cardContent}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }